export default function togglePlayVideo(element)  {
  if (element.paused) {
    const promise = element.play();

    if (promise !== undefined) {
      promise
        .then(() => console.log("Successfully invoked play()"))
        .catch(error => console.log("Failed to invoke play()", error));
    }
  } else {
    const promise = element.pause();

    if (promise !== undefined) {
      promise
        .then(() => console.log("Successfully invoked pause()  by click", element))
        .catch(error => console.log("Failed to invoke pause() bly click", error));
    }
  }
}
